import LoanList from "./LoanList";
import LoanShow from "./LoanShow";

const Loan = { list: LoanList, show: LoanShow };

export default Loan;
